<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Campaign
            </template>
            <template v-slot:pageDetail>
                List
            </template>
            <template v-slot:pageDescription>
                <br>
            </template>
        </o-bread-crumb>
        <div v-if="validation">
            <div class="alert alert-danger mt-1" role="alert">
                {{ validation }}
            </div>
        </div>
        <div v-if="thisComponentShow" class="card text-center">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <a class="nav-link text-dark fs-4" href="#">Campaign Register</a>
                        </div>
                    </li>
                    <!-- Add Campaign Button -->
                    <li class="nav-item add-campaign-btn d-flex gap-2">
                        <!-- Add Campaign Button -->
                        <o-button @click="showModal" class="add-campaign-btn btn btn-primary btn-sm" style="color: white;">
                            Add Campaign
                        </o-button>

                        <!-- Generate Campaign Button (Only visible when condition is met) -->
                        <o-button v-if="shouldShowGenerateCampaign" @click="generateCampaign" class="generate-campaign-btn btn btn-primary btn-sm" style="color: white;">
                            Generate Campaign
                        </o-button>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
                <div class="spinner" v-if='page.isLoading'></div>
                <div v-if="page.output">
                    <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                        <li class="nav-item">
                            <div class="d-flex d-inline-block">
                                <o-search :searchOptions="searchOptions" @submit="search" @clear="clearSearch"></o-search>
                            </div>
                        </li>
                        <li class="nav-item btn btn-primary btn-sm">
                            <button class="reload nav-link text-white" @click.prevent="load_state()">&#x21bb;</button>
                        </li>
                    </ul>
                    <o-table style="text-align:left;" class="table-hover">
                        <thead>
                            <tr>
                                <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                    {{ field }}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in campaigns" :key="index">
                                <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                                <td>{{ item.name }}</td>
                                <td class="ml-3">
                                    <div class="d-flex">
                                        <div class="me-1">
                                            <button class="btn btn-sm btn-info rounded-pill text-white" v-if="write" @click="editModal(item)">
                                                Edit
                                            </button>
                                        </div>
                                        <div v-if="write && !shouldHideDeleteButton(item) && item.member_register_trackers.length == 0">
                                            <button class="btn btn-sm btn-danger rounded-pill text-white" @click.prevent="destroy(item.id)">
                                                Delete
                                            </button>
                                        </div>
                                        <div v-if="write && !shouldHideDeleteButton(item) && item.member_register_trackers.length > 0">
                                            <button class="btn btn-sm btn-danger rounded-pill text-white" @click.prevent="showDeleteOptions(item)">
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="campaigns.length === 0">
                                <td colspan="3" class="text-center">No campaigns available</td>
                            </tr>
                        </tbody>
                    </o-table>
                </div>
            </div>
            <div class="container mt-5">
                <o-pagination :page="meta.page" :total="meta.total" @callback="navPage"/>
            </div>
        </div>

        <!-- Campaign Form Modal -->
        <campaign-form
            v-if="isModalVisible && modalType === 'addCampaign'"
            @parentSaveItem="saveDetail"
            @parentCloseModal="closeModal"
            :editedItem="editedItem"
        ></campaign-form>

        <!-- Campaign Delete Options Modal -->
        <o-modal 
            v-if="isDeleteOptionsModalVisible" 
            @close="closeDeleteOptionsModal"
            modal-class="show d-block warning-style-modal"
        >
            <template v-slot:header>
                <div class="warning-style-header">
                    <div class="header-icon">
                        <svg
                            aria-hidden="true"
                            stroke="currentColor"
                            stroke-width="1.5"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                                stroke-linejoin="round"
                                stroke-linecap="round"
                            ></path>
                        </svg>
                    </div>
                    <div class="header-content">
                        <span class="header-title">Delete Campaign Options</span>
                        <p class="header-message">This campaign has {{ selectedCampaignForDelete?.member_register_trackers?.length || 0 }} associated members. Choose how to proceed:</p>
                    </div>
                </div>
            </template>
            <template v-slot:body>
                <div class="warning-style-body">
                    <div class="horizontal-actions">
                        <button 
                            class="warning-btn detach-btn"
                            @click="showDetachConfirmation"
                            :disabled="isProcessing"
                        >
                            <i class="fas fa-unlink"></i>
                            Detach Members
                        </button>
                        
                        <button 
                            class="warning-btn reassign-btn"
                            @click="showReassignConfirmation"
                            :disabled="isProcessing"
                        >
                            <i class="fas fa-exchange-alt"></i>
                            Reassign Members
                        </button>
                        
                        <button 
                            class="warning-btn cancel-btn"
                            @click="closeDeleteOptionsModal"
                            :disabled="isProcessing"
                        >
                            <i class="fas fa-times"></i>
                            Cancel
                        </button>
                    </div>
                </div>
            </template>
        </o-modal>

        <!-- Reassign Campaign Modal -->
        <o-modal 
            v-if="isReassignModalVisible" 
            @close="closeReassignModal"
            modal-class="show d-block warning-style-modal"
        >
            <template v-slot:header>
                <div class="warning-style-header">
                    <div class="header-icon">
                        <i class="fas fa-exchange-alt"></i>
                    </div>
                    <div class="header-content">
                        <span class="header-title">Reassign Members</span>
                        <p class="header-message">{{ selectedCampaignForDelete?.member_register_trackers?.length || 0 }} members will be moved to the selected campaign.</p>
                    </div>
                </div>
            </template>
            <template v-slot:body>
                <div class="warning-style-body">
                    <div class="form-section">
                        <label for="targetCampaign" class="form-label">Target Campaign:</label>
                        <select 
                            id="targetCampaign"
                            class="form-select warning-select"
                            v-model="selectedTargetCampaign"
                            :disabled="isProcessing"
                        >
                            <option value="" disabled>Choose destination campaign...</option>
                            <option 
                                v-for="campaign in availableCampaigns" 
                                :key="campaign.id" 
                                :value="campaign.id"
                            >
                                {{ campaign.name }}
                            </option>
                        </select>
                    </div>
                    
                    <div class="horizontal-actions">
                        <button 
                            class="warning-btn confirm-btn"
                            @click="reassignMembers"
                            :disabled="!selectedTargetCampaign || isProcessing"
                        >
                            <i class="fas fa-check"></i>
                            {{ isProcessing && actionType === 'reassign' ? 'Processing...' : 'Confirm' }}
                        </button>
                        
                        <button 
                            class="warning-btn back-btn"
                            @click="closeReassignModal"
                            :disabled="isProcessing"
                        >
                            <i class="fas fa-arrow-left"></i>
                            Back
                        </button>
                    </div>
                </div>
            </template>
        </o-modal>

        <!-- Detach Confirmation Alert -->
        <o-warning-box
            v-if="isDetachConfirmationVisible"
            title="Confirm Detach Members"
            :message="`Are you sure you want to detach all ${selectedCampaignForDelete?.member_register_trackers?.length || 0} members from this campaign? Members will remain in the system but will no longer be associated with this campaign.`"
            action-text="Yes, Detach Members"
            cancel-text="Cancel"
            @action="confirmDetachMembers"
            @cancel="closeDetachConfirmation"
        />

        <!-- Reassign Confirmation Alert -->
        <o-warning-box
            v-if="isReassignConfirmationVisible"
            title="Confirm Reassign Members"
            :message="`This will move all ${selectedCampaignForDelete?.member_register_trackers?.length || 0} members to another campaign. You will need to select the target campaign in the next step.`"
            cancel-text="Cancel"
            action-text="Continue to Reassign"
            @cancel="closeReassignConfirmation"
            @action="confirmReassignMembers"
        />

        <!-- Simple Delete Confirmation for campaigns without members -->
        <o-warning-box
            v-if="isSimpleDeleteConfirmationVisible"
            title="Delete Campaign"
            :item-name="selectedCampaignForDelete?.name || 'this campaign'"
            warning-message="This action cannot be undone."
            confirm-text="Yes, Delete Campaign"
            cancel-text="Cancel"
            @confirm="confirmSimpleDelete"
            @cancel="closeSimpleDeleteConfirmation"
        />

        <!-- Single Multi-step Delete Modal -->
        <o-modal 
            v-if="isDeleteModalVisible" 
            @close="closeDeleteModal"
            modal-class="show d-block warning-style-modal"
        >
            <template v-slot:header>
                <div class="warning-style-header">
                    <div class="header-icon">
                        <svg v-if="deleteStep === 'options'"
                            aria-hidden="true"
                            stroke="currentColor"
                            stroke-width="1.5"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                                stroke-linejoin="round"
                                stroke-linecap="round"
                            ></path>
                        </svg>
                        <i v-else-if="deleteStep === 'reassign'" class="fas fa-exchange-alt"></i>
                        <i v-else-if="deleteStep === 'detach-confirm'" class="fas fa-unlink"></i>
                        <i v-else-if="deleteStep === 'reassign-confirm'" class="fas fa-check-circle"></i>
                    </div>
                    <div class="header-content">
                        <span class="header-title">{{ getStepTitle() }}</span>
                        <p class="header-message">{{ getStepMessage() }}</p>
                    </div>
                </div>
            </template>
            <template v-slot:body>
                <div class="warning-style-body">
                    <!-- Step 1: Delete Options -->
                    <div v-if="deleteStep === 'options'" class="horizontal-actions">
                        <button 
                            class="warning-btn detach-btn"
                            @click="goToDetachConfirm"
                            :disabled="isProcessing"
                        >
                            <i class="fas fa-unlink"></i>
                            Detach Members
                        </button>
                        
                        <button 
                            v-if="availableCampaigns.length > 0"
                            class="warning-btn reassign-btn"
                            @click="goToReassignConfirm"
                            :disabled="isProcessing"
                        >
                            <i class="fas fa-exchange-alt"></i>
                            Reassign Members
                        </button>
                        
                        <button 
                            class="warning-btn cancel-btn"
                            @click="closeDeleteModal"
                            :disabled="isProcessing"
                        >
                            <i class="fas fa-times"></i>
                            Cancel
                        </button>
                    </div>

                    <!-- Step 2: Reassign Campaign Selection -->
                    <div v-else-if="deleteStep === 'reassign'" class="reassgin-container">
                        <div class="form-section">
                            <label for="targetCampaign" class="form-label">Target Campaign:</label>
                            <select 
                                id="targetCampaign"
                                class="form-select warning-select"
                                v-model="selectedTargetCampaign"
                                :disabled="isProcessing"
                            >
                                <option value="" disabled>Choose destination campaign...</option>
                                <option 
                                    v-for="campaign in availableCampaigns" 
                                    :key="campaign.id" 
                                    :value="campaign.id"
                                >
                                    {{ campaign.name }}
                                </option>
                            </select>
                        </div>
                        
                        <div class="horizontal-actions">
                            <button 
                                class="warning-btn confirm-btn"
                                @click="reassignMembers"
                                :disabled="!selectedTargetCampaign || isProcessing"
                            >
                                <i class="fas fa-check"></i>
                                {{ isProcessing && actionType === 'reassign' ? 'Processing...' : 'Confirm Reassign' }}
                            </button>
                            
                            <button 
                                class="warning-btn back-btn"
                                @click="goBackToOptions"
                                :disabled="isProcessing"
                            >
                                <i class="fas fa-arrow-left"></i>
                                Back
                            </button>
                        </div>
                    </div>

                    <!-- Step 3: Detach Confirmation -->
                    <div v-else-if="deleteStep === 'detach-confirm'">
                        <div class="confirmation-message">
                            <p>Are you sure you want to detach all {{ selectedCampaignForDelete?.member_register_trackers?.length || 0 }} members from this campaign?</p>
                            <p class="text-muted">Members will remain in the system but will no longer be associated with this campaign.</p>
                        </div>
                        
                        <div class="horizontal-actions">
                            <button 
                                class="warning-btn confirm-btn"
                                @click="detachAllMembers"
                                :disabled="isProcessing"
                            >
                                <i class="fas fa-check"></i>
                                {{ isProcessing && actionType === 'detach' ? 'Processing...' : 'Yes, Detach Members' }}
                            </button>
                            
                            <button 
                                class="warning-btn back-btn"
                                @click="goBackToOptions"
                                :disabled="isProcessing"
                            >
                                <i class="fas fa-arrow-left"></i>
                                Back
                            </button>
                        </div>
                    </div>

                    <!-- Step 4: Reassign Confirmation -->
                    <div v-else-if="deleteStep === 'reassign-confirm'">
                        <div class="confirmation-message">
                            <p>This will move all {{ selectedCampaignForDelete?.member_register_trackers?.length || 0 }} members to another campaign.</p>
                            <p class="text-muted">You will need to select the target campaign in the next step.</p>
                        </div>
                        
                        <div class="horizontal-actions">
                            <button 
                                class="warning-btn confirm-btn"
                                @click="goToReassign"
                                :disabled="isProcessing"
                            >
                                <i class="fas fa-arrow-right"></i>
                                Continue to Reassign
                            </button>
                            
                            <button 
                                class="warning-btn back-btn"
                                @click="goBackToOptions"
                                :disabled="isProcessing"
                            >
                                <i class="fas fa-arrow-left"></i>
                                Back
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </o-modal>

        <!-- Warning box for members with pending campaigns -->
        <o-warning-box
            v-if="isPendingTransactionWarningVisible"
            title="Cannot Delete Campaign"
            message = "This campaign cannot be deleted because it has been used in a member register tracker. Please resolve all related records before attempting to delete this campaign."
            action-text="Understood"
            cancel-text="Close"
            @action="closePendingTransactionWarning"
            @cancel="closePendingTransactionWarning"
            :hide-action="true"
        />
    </div>
</template>

<script>
import store from '@/store/'
import { mapState } from 'vuex'
import { OTable, OPagination, OBreadCrumb, OSearch, OWarningBox, OModal } from '@/components/OmnihControl'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useToast } from '@/composables/useToast'
import CampaignForm from './CampaignForm.vue';

export default {
    setup() {
        let meta = computed(() => store.state.Campaign.meta)

        let page = reactive({
            isLoading: false,
            output: false,
            component: 'campaign'
        });

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        const write = ref(false);

        let fields = ref([
            'No',
            'Name',
            'Action'
        ]);

        const validation = ref('');

        const selectedBusinessProfile = reactive({
            corporate_id: null
        });

        const selectCampaign = ref();

        const searchBy = reactive({
            selected: "name",  // The field to search
            criteria: "",      // The search term
        });

        const searchOptions = reactive([
            { value: 'name', text: 'name' }
        ])

        const thisComponentShow = ref(false);

        // Modal related state
        const isModalVisible = ref(false);
        const modalType = ref('');
        const editedItem = ref(null);
        // For pending transaction warning
        const isPendingTransactionWarningVisible = ref(false);

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    loadSelectedBusinessProfile();
                }
            }
        );

        onMounted(() => {
            if (selfLoaded.value) {
                loadSelectedBusinessProfile();
            }
        });


        const campaigns = computed(() => store.state.Campaign.campaigns);
        const { showToast } = useToast()
        const shouldHideDeleteButton = (campaign) => {
            if (!campaign.unique) return false;
            const unique = campaign.unique.toLowerCase();
            return unique.includes('be') || unique.includes('corp');
        }
        const shouldShowGenerateCampaign = computed(() => {
            let foundBe = store.state.Campaign.foundCampaigns.includes('be');
            let foundCorp = store.state.Campaign.foundCampaigns.includes('corp');

            if (foundBe || foundCorp) {
                return false;
            }

            const existingCampaigns = campaigns.value.map(item => item.unique);

            if (existingCampaigns.includes('be')) {
                store.dispatch('Campaign/addCampaignToFound', 'be');
            }

            if (existingCampaigns.includes('corp')) {
                store.dispatch('Campaign/addCampaignToFound', 'corp');
            }

            return !existingCampaigns.includes("be") || !existingCampaigns.includes("corp");
        });

        function generateCampaign() {
            store.dispatch('Campaign/generate')
                .then(() => {
                    console.log("Generate campaign action dispatched.");
                    load_state();  // Reload campaigns after generation
                })
                .catch((err) => {
                    console.error(err);
                    validation.value = err.response.data.message;
                });
        }
        // Show modal for adding a new campaign
        function showModal() {
            modalType.value = 'addCampaign';
            isModalVisible.value = true;
            editedItem.value = null; // Reset for new campaign
        }

        // Show modal for editing an existing campaign
        function editModal(item) {
            modalType.value = 'addCampaign';
            isModalVisible.value = true;
            editedItem.value = item; // Set data for editing
        }

        // Close Modal
        function closeModal() {
            isModalVisible.value = false;
            modalType.value = '';
            editedItem.value = null;
        }

        // Save Campaign (Create or Update)
        function saveDetail(dataFromChild) {
            const formattedData = {
                name: dataFromChild.name || "",
                id: dataFromChild.id || null,
            };

            if (formattedData.name.trim() === "") {
                validation.value = "Campaign name is required.";
                return;
            }

            const isUpdate = !!formattedData.id
            const action = isUpdate ? 'Campaign/update' : 'Campaign/create'

            store.dispatch(action, { data: formattedData })
                .then((response) => {
                    load_state()
                    closeModal()

                    const campaignName = response?.data?.data?.name || formattedData.name || '-'

                    showToast({
                        type: 'success',
                        title: isUpdate ? 'Update Successful' : 'Creation Successful',
                        message: isUpdate
                            ? `Campaign "${campaignName}" has been successfully updated.`
                            : `Campaign "${campaignName}" has been successfully created.`,
                    })
                })
                .catch((err) => {
                    console.error(err)
                    const errorMessage = err.response?.data?.message || 'Failed to save campaign'
                    validation.value = errorMessage
                    showToast({
                        type: 'error',
                        title: 'Save Failed',
                        message: errorMessage,
                    })
                })
        }

        function load_state() {
            page.isLoading = true;

            store.dispatch('Campaign/read')
                .then(() => {
                    if (store.state.Auth.currUser.level === 'root') {
                        write.value = true;
                        thisComponentShow.value = true;
                    } else {
                        const userModules = store.state.Auth.userInfo.modules;
                        if (userModules) {
                            const matchingModule = userModules.find(module => module.module_name === page.component);
                            write.value = matchingModule ? matchingModule.write : false;
                            thisComponentShow.value = matchingModule ? true : false;
                        }
                    }
                })
                .catch((err) => {
                    validation.value = err.response.data.message;
                    console.error(err);
                })
                .finally(() => {
                    page.isLoading = false;
                    page.output = true;
                });
        }

        function search(searchBy) {
            const { selected, criteria } = searchBy;

            if (!criteria) {
                return;
            }

            let search = {};
            search[selected] = criteria;
            store.commit('Campaign/set_search', { search });

            const updatedMeta = { ...meta.value, page: 1 };
            store.commit('Campaign/switch_page', { meta: updatedMeta });
            store.dispatch('Campaign/read').then(() => {});
        }

        function clearSearch() {
            store.commit('Campaign/clear_search');
            store.dispatch('Campaign/read').then(() => {});
        }

        function destroy(id) {
            // Find the campaign to get its details
            const campaign = campaigns.value.find(c => c.id === id);
            if (campaign) {
                selectedCampaignForDelete.value = campaign;
                isSimpleDeleteConfirmationVisible.value = true;
            }
        }
        
        function closeSimpleDeleteConfirmation() {
            isSimpleDeleteConfirmationVisible.value = false;
            selectedCampaignForDelete.value = null;
        }
        
        function confirmSimpleDelete() {
            if (selectedCampaignForDelete.value) {
                const deletedName = selectedCampaignForDelete.value.name
                store.dispatch('Campaign/delete', selectedCampaignForDelete.value.id)
                    .then(() => {
                        navPage(1);
                        load_state();
                        showToast({
                            type: 'success',
                            title: 'Deletion Successful',
                            message: `Campaign "${deletedName}" has been successfully deleted.`,
                        })
                    })
                    .catch((err) => {
                        console.error(err);
                        const errorMessage = err.response?.data?.message || 'Failed to delete campaign'
                        validation.value = errorMessage;
                        showToast({
                            type: 'error',
                            title: 'Deletion Failed',
                            message: errorMessage,
                        })
                    })
                    .finally(() => {
                        closeSimpleDeleteConfirmation();
                    });
            }
        }

        async function loadSelectedBusinessProfile() {
            await store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                selectedBusinessProfile.corporate_id = businessProfile.corporate_id;
            }).finally(() => {
                load_state();
            });
        }

        function showPendingTransactionWarning() {
            isPendingTransactionWarningVisible.value = true;
        }
        
        function closePendingTransactionWarning() {
            isPendingTransactionWarningVisible.value = false;
        }

        function navPage(page) {
            const updatedMeta = { ...meta.value, page };
            store.commit('Campaign/switch_page', { meta: updatedMeta });
            store.dispatch('Campaign/read').then(() => {
                console.log(`${page}`);
            }).catch((err) => {
                console.error("Error memuat data kampanye:", err);
            });
        }

        // For single multi-step delete modal
        const isDeleteModalVisible = ref(false);
        const deleteStep = ref('options'); // 'options', 'reassign', 'detach-confirm', 'reassign-confirm'
        const selectedCampaignForDelete = ref(null);
        const selectedTargetCampaign = ref('');
        const isProcessing = ref(false);
        const actionType = ref('');
        
        // Keep old modal states for backward compatibility
        const isDeleteOptionsModalVisible = ref(false);
        const isReassignModalVisible = ref(false);
        const isDetachConfirmationVisible = ref(false);
        const isReassignConfirmationVisible = ref(false);
        const isSimpleDeleteConfirmationVisible = ref(false);

        // Computed property for available campaigns (excluding the one being deleted)
        const availableCampaigns = computed(() => {
            if (!selectedCampaignForDelete.value) return campaigns.value;
            return campaigns.value.filter(campaign => campaign.id !== selectedCampaignForDelete.value.id);
        });

        // Modified function to show delete options
        function showDeleteOptions(campaign) {
            selectedCampaignForDelete.value = campaign;
            deleteStep.value = 'options';
            isDeleteModalVisible.value = true;
        }

        function closeDeleteModal() {
            isDeleteModalVisible.value = false;
            deleteStep.value = 'options';
            selectedCampaignForDelete.value = null;
            selectedTargetCampaign.value = '';
            isProcessing.value = false;
            actionType.value = '';
        }

        // Step navigation functions
        function goToDetachConfirm() {
            deleteStep.value = 'detach-confirm';
        }

        function goToReassignConfirm() {
            deleteStep.value = 'reassign-confirm';
        }

        function goToReassign() {
            deleteStep.value = 'reassign';
            selectedTargetCampaign.value = '';
        }

        function goBackToOptions() {
            deleteStep.value = 'options';
        }

        // Helper functions for dynamic content
        function getStepTitle() {
            switch (deleteStep.value) {
                case 'options':
                    return 'Delete Campaign Options';
                case 'reassign':
                    return 'Reassign Members';
                case 'detach-confirm':
                    return 'Confirm Detach Members';
                case 'reassign-confirm':
                    return 'Confirm Reassign Members';
                default:
                    return 'Delete Campaign';
            }
        }

        function getStepMessage() {
            const memberCount = selectedCampaignForDelete.value?.member_register_trackers?.length || 0;
            switch (deleteStep.value) {
                case 'options':
                    return `This campaign has ${memberCount} associated members. Choose how to proceed:`;
                case 'reassign':
                    return `${memberCount} members will be moved to the selected campaign.`;
                case 'detach-confirm':
                    return `Confirm detaching ${memberCount} members from this campaign.`;
                case 'reassign-confirm':
                    return `Prepare to reassign ${memberCount} members to another campaign.`;
                default:
                    return '';
            }
        }

        function closeDeleteOptionsModal() {
            isDeleteOptionsModalVisible.value = false;
            selectedCampaignForDelete.value = null;
            isProcessing.value = false;
            actionType.value = '';
        }

        function showReassignModal() {
            isReassignModalVisible.value = true;
            selectedTargetCampaign.value = '';
        }

        function closeReassignModal() {
            isReassignModalVisible.value = false;
            selectedTargetCampaign.value = '';
        }

        // Detach all members from campaign
        async function detachAllMembers() {
            if (!selectedCampaignForDelete.value) return;

            isProcessing.value = true;
            actionType.value = 'detach';

            try {
                await store.dispatch('Campaign/detachMembers', selectedCampaignForDelete.value.id);
                const deletedName = selectedCampaignForDelete.value.name
                await store.dispatch('Campaign/delete', selectedCampaignForDelete.value.id);

                load_state();
                closeDeleteModal();
                validation.value = '';
                showToast({
                    type: 'success',
                    title: 'Deletion Successful',
                    message: `Campaign "${deletedName}" has been deleted after detaching its members.`,
                })
            } catch (err) {
                console.error(err);
                const errorMessage = err.response?.data?.message || 'Failed to detach members';
                validation.value = errorMessage;
                showToast({
                    type: 'error',
                    title: 'Detach Failed',
                    message: errorMessage,
                })
            } finally {
                isProcessing.value = false;
                actionType.value = '';
            }
        }

        async function reassignMembers() {
            if (!selectedCampaignForDelete.value || !selectedTargetCampaign.value) return;

            isProcessing.value = true;
            actionType.value = 'reassign';

            try {
                await store.dispatch('Campaign/reassignMembers', {
                    fromCampaignId: selectedCampaignForDelete.value.id,
                    toCampaignId: selectedTargetCampaign.value
                });

                const deletedName = selectedCampaignForDelete.value.name
                await store.dispatch('Campaign/delete', selectedCampaignForDelete.value.id);

                load_state();
                closeDeleteModal();
                validation.value = '';
                showToast({
                    type: 'success',
                    title: 'Deletion Successful',
                    message: `Campaign "${deletedName}" has been deleted after reassigning its members.`,
                })
            } catch (err) {
                console.error(err);
                const errorMessage = err.response?.data?.message || 'Failed to reassign members';
                validation.value = errorMessage;
                showToast({
                    type: 'error',
                    title: 'Reassign Failed',
                    message: errorMessage,
                })
            } finally {
                isProcessing.value = false;
                actionType.value = '';
            }
        }

        function showDetachConfirmation() {
            isDetachConfirmationVisible.value = true;
        }

        function closeDetachConfirmation() {
            isDetachConfirmationVisible.value = false;
        }

        function confirmDetachMembers() {
            isDetachConfirmationVisible.value = false;
            detachAllMembers();
        }

        function showReassignConfirmation() {
            isReassignConfirmationVisible.value = true;
        }

        function closeReassignConfirmation() {
            isReassignConfirmationVisible.value = false;
        }

        function confirmReassignMembers() {
            isReassignConfirmationVisible.value = false;
            showReassignModal();
        }

        return {
            page,
            saveDetail,
            showModal,
            closeModal,
            editModal,
            load_state,
            loadSelectedBusinessProfile,
            fields,
            searchBy,
            searchOptions,
            validation,
            isModalVisible,
            modalType,
            editedItem,
            write,
            selfLoaded,
            selectedBusinessProfile,
            meta,
            selectCampaign,
            thisComponentShow,
            destroy,
            search,
            clearSearch,
            generateCampaign,
            shouldShowGenerateCampaign,
            shouldHideDeleteButton,
            isPendingTransactionWarningVisible,
            showPendingTransactionWarning,
            closePendingTransactionWarning,
            navPage,
            showDeleteOptions,
            isDeleteModalVisible,
            deleteStep,
            selectedCampaignForDelete,
            selectedTargetCampaign,
            isProcessing,
            actionType,
            availableCampaigns,
            closeDeleteModal,
            goToDetachConfirm,
            goToReassignConfirm,
            goToReassign,
            goBackToOptions,
            getStepTitle,
            getStepMessage,
            detachAllMembers,
            reassignMembers,
            isDeleteOptionsModalVisible,
            isReassignModalVisible,
            closeDeleteOptionsModal,
            showReassignModal,
            closeReassignModal,
            isDetachConfirmationVisible,
            isReassignConfirmationVisible,
            showDetachConfirmation,
            closeDetachConfirmation,
            confirmDetachMembers,
            showReassignConfirmation,
            closeReassignConfirmation,
            confirmReassignMembers,
            isSimpleDeleteConfirmationVisible,
            closeSimpleDeleteConfirmation,
            confirmSimpleDelete,
        }
    },
    computed: {
        ...mapState({
            campaigns: state => state.Campaign.campaigns,
        }),
    },
    components: {
        OTable,
        OPagination,
        OBreadCrumb,
        OSearch,
        CampaignForm,
        OWarningBox,
        OModal
    }
}
</script>
<style scoped>
/* Warning Style Modal */
.warning-style-modal :deep(.modal-dialog) {
    max-width: fit-content;
    margin: 2rem auto;
}

.warning-style-modal :deep(.modal-content) {
    width: fit-content;
    border: none;
    border-radius: 0.5rem;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    background-color: #ffffff;
    animation: slideIn 0.3s ease-out;
}
.warning-style-modal {
    overflow: hidden !important;
}


.reassgin-container {
    width: 100%;
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.warning-style-header {
    padding: 1.25rem 1rem 1rem 1rem;
    background-color: #ffffff;
    text-align: center;
}

.header-icon {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    background-color: #fee2e2;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    border-radius: 9999px;
    margin-bottom: 0.75rem;
}

.header-icon svg {
    color: #dc2626;
    width: 1.5rem;
    height: 1.5rem;
}

.header-icon i {
    color: #dc2626;
    font-size: 1.5rem;
}

.header-content {
    text-align: center;
}

.header-title {
    color: #111827;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
    display: block;
    margin-bottom: 0.5rem;
}

.header-message {
    margin: 0;
    color: #6b7280;
    font-size: 0.875rem;
    line-height: 1.25rem;
}

.warning-style-body {
    width: 100%;
    padding: 0 1rem 1.25rem 1rem;
    background-color: #ffffff;
}

.horizontal-actions {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    gap: 0.5rem;
    margin-top: 0.75rem;
}

.warning-btn {
    flex: 1;
    display: inline-flex;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    border-radius: 0.375rem;
    border: 1px solid transparent;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.2s ease;
}

.warning-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.warning-btn i {
    font-size: 0.875rem;
}

.detach-btn {
    background-color: #dc2626;
    color: #ffffff;
}

.detach-btn:hover:not(:disabled) {
    background-color: #b91c1c;
}

.reassign-btn {
    background-color: #dc2626;
    color: #ffffff;
}

.reassign-btn:hover:not(:disabled) {
    background-color: #b91c1c;
}

.confirm-btn {
    background-color: #dc2626;
    color: #ffffff;
}

.confirm-btn:hover:not(:disabled) {
    background-color: #b91c1c;
}

.cancel-btn,
.back-btn {
    background-color: #ffffff;
    color: #374151;
    border: 1px solid #d1d5db;
}

.cancel-btn:hover:not(:disabled),
.back-btn:hover:not(:disabled) {
    background-color: #f3f4f6;
}

.form-section {
    margin-bottom: 1rem;
}

.form-label {
    display: block;
    color: #374151;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.warning-select {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    background-color: #ffffff;
    font-size: 0.875rem;
    color: #374151;
}

.warning-select:focus {
    outline: none;
    border-color: #dc2626;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.warning-select:disabled {
    background-color: #f9fafb;
    cursor: not-allowed;
}

.confirmation-message {
    max-width: 493px;
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 0.375rem;
    margin-bottom: 1.5rem;
    border-left: 4px solid #dc2626;
}

.confirmation-message p {
    margin-bottom: 0.5rem;
}

.confirmation-message p:last-child {
    margin-bottom: 0;
}

.form-section {
    margin-bottom: 1.5rem;
}

.form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #374151;
}

/* Responsive */
@media (max-width: 576px) {
    .warning-style-modal :deep(.modal-dialog) {
        margin: 1rem;
        max-width: none;
    }
    
    .horizontal-actions {
        flex-direction: column;
        gap: 0.75rem;
    }
    
    .warning-btn {
        width: 100%;
    }
}
</style>
